export enum GlobalRoutes {
  LOGIN = "/login",
  LOGOUT = "/logout",
  ForgotPassword = "/forgot-password",
  ResetPassword = "/reset-password/:token",
  PAGE_404 = "/404",
}

export enum ContentRoutes {
  USERS = "/users-tab",
  USERS_TAB = "/users-tab",
  CREATE_USER = "/user/create",
  UPDATE_USER = "/user/update/:id",
  IMPORT_CUSTOMERS = "import-customers",
  DASHBOARD = "/dashboard",
  VIEW_UPDATE_PROFILE = "/my-profile",

  CAMPAIGNS = "/campaigns",
  CREATE_CAMPAIGN_CUSTOMER = "/campaign-customer/create",

  CUSTOMERS = "/customers",
  CREATE_CUSTOMER = "/customer/create",
  UPDATE_CUSTOMER = "/customer/update/:id",
  FOLLOWUPS = "/followups/:id",

  ORDERS = "/orders",
  CREATE_ORDER = "/order/create",
  UPDATE_ORDER = "/order/update/:id",
  UPDATE_ORDER_RATING = "/order/update-rating/:id",

  ROLES = "/roles",
  DOWN_ROLES = "/down-roles",
  COUNTRIES = "/countries",
  LOGOUT = "/logout",
  STORES = "/stores",
  CREATE_STORE = "/store/create",
  UPDATE_STORE = "/store/update/:id",
  CONTRACTS = "/contracts",
  CREATE_CONTRACT = "/contract/create",
  UPDATE_CONTRACT = "/contract/update/:id",
  COMPANIES = "/companies",
  CREATE_COMPANY = "/company/create",
  UPDATE_COMPANY = "/company/update/:id",
  PRODUCTS = "/products",
  COMPANY_PRODUCTS = "/company-products",
  STORE_PRODUCTS = "/store-products",
  CREATE_PRODUCT = "/product/create",
  UPDATE_PRODUCT = "/product/update/:id",
  IMPORT_PRODUCTS_FOR_COMPANY = "/import-products-for-company/:id",
  IMPORT_PRODUCTS_FOR_STORE = "/import-products-for-store/:id",
  CITIES = "/cities",
  AREAS = "/areas",
  BUILDINGS = "/buildings",
  IMPORT_BUILDINGS = "/import-buildings",
  IMPORT_AREAS = "/import-areas",
  NOTIFICATION = "/notification",
  PAGE_401 = "/401",
}

export const ContentIdRoutes = [
  { path: "/user/update/:id" },
  { path: "/order/update/:id" },
  { path: "/company/update/:id" },
  { path: "/customer/update/:id" },
  { path: "/product/update/:id" },
  { path: "/store/update/:id" },
  { path: "/order/update/:id" },
  { path: "/import-products-for-company/:id" },
  { path: "/import-products-for-store/:id" },
];

export enum ContentApiRoutes {
  REPLACE_ROLE_PERMISSIONS = "/replace-roles-permissions",
  CREATE_NOTIFICATION = "/notification",
  UPDATE_NOTIFICATION = "/notification/:id",
  DELETE_NOTIFICATION = "/notification/:id",
  VIEW_NOTIFICATION = "/notifications/:id",
  NOTIFICATION = "/notification",
  NOTIFICATION_COUNT = "/new-notification-count",
  READ_NOTIFICATION = "/read-notifications",
  RECIEVE_NOTIFICATION = "/received-notifications",
  LOGIN_ADMIN = "/login-admin",
  DASHBOARD_ADMIN_AGG_REPORT = "/admin-aggregate-report",
  DASHBOARD_AGG_REPORT = "/aggregate-report",
  COUNTRIES = "/countries",
  STATES = "/states",
  CITIES = "/cities",
  IMPORT_AREA = "/import-area",
  AADMIN_THEMES = "/admin-themes",
  AREAS = "/areas",
  CREATE_STATE = "/state",
  UPDATE_STATE = "/state/:id",
  DELETE_STATE = "/state/:id",
  CREATE_CITY = "/city",
  UPDATE_DELETE_CITY = "/city/",
  UPDATE_CITY = "/city/:id",
  DELETE_CITY = "/city/:id",
  ADD_AREA = "/area",
  UPDATE_AREA = "/area/",
  DELETE_AREA = "/area/",
  IMPORT_BUILDINGS = "/import-building",
  BUILDINGS = "/buildings",
  ADD_BUILDING = "/building",
  UPDATE_BUILDING = "/building/",
  DELETE_BUILDING = "/building/",
  RESET_PASSWORD_LINK = "/generate-reset-password-link",
  RESET_PASSWORD_TOKEN = "/reset-password-by-token",
  VALIDATE_PASSWORD_TOKEN = "/validate-password-token",
  ROLES = "/roles/",
  LICENSES = "licenses",
  PERMISSIONS = "/permissions",
  ROLE_PERMISSIONS = "/roles/permissions/",
  ASSIGN_ROLE_PERMISSIONS = "/assign-roles-permissions",
  STORES = "/stores",
  CREATE_STORE = "/store",
  UPDATE_STORE = "/store/:id",
  DELETE_STORE = "/store/:id",
  VIEW_STORE = "/stores/:id",
  EXPORT_STORES = "/export-stores",
  PUBLISH_STORE = "/publish-store/:id",
  PUBLISH_BULK_STORE = "/publish-bulk-store/",
  DELETE_BULK_STORE = "/delete-bulk-store/",
  ASSIGN_BULK_STORE_GROUP = "/assign-store-group/",
  FOLLOWUPS = "/followups",
  FOLLOWUP = "/followup",
  CREATE_FOLLOWUP = "/followup",
  UPDATE_FOLLOWUP = "/followup/:id",
  DELETE_FOLLOWUP = "/followup/:id",
  VIEW_FOLLOWUP = "/followups/:id",
  UPDATE_FOLLOWUP_COMMENT = "/followup-comment/:id",
  DELETE_FOLLOWUP_COMMENT = "/followup-comment/:id",
  USER = "/user",
  CREATE_USER = "/user",
  UPDATE_USER = "/user/:id",
  DELETE_USER = "/user/:id",
  VIEW_USER = "/users/:id",
  UPLOAD_USER_IMAGE = "/user/:id",
  USERS = "/users",
  STORE_STAVES = "/store-staves",
  EXPORT_USERS = "/export-users",
  PUBLISH_USER = "/publish-user/:id",
  PUBLISH_BULK_USER = "/publish-bulk-user/",
  DELETE_BULK_USER = "/delete-bulk-user/",
  CHANGE_PASSWORD = "/change-password",
  CHANGE_USER_SETTINGS = "/save-settings",
  GET_USER_SETTINGS = "/my-settings",
  LOGOUT = "/logout",
  STORE_GROUPS = "/store-groups",
  REGIONS = "/regions",
  LOGGED_IN_USER_DETAIL = "/me",
  DELETE_USER_IMAGE = "/delete-user-image/:id",
  CREATE_USER_ADDRESS = "/user-address",
  UPDATE_USER_ADDRESS = "/user-address/:id",
  DELETE_USER_ADDRESS = "/user-address/:id",
  PUBLISH_USER_ADDRESS = "/publish-user-address/:id",
  CHECK_USER_AVAILABLITY = "/check-user",
  ROLES_BY_USER_TYPE = "/roles?role_type=:roleType",
  DOWN_ROLES_BY_ROLE_TYPE = "/down-roles?role_type=:roleType",

  CUSTOMER = "/customer",
  CREATE_CUSTOMER = "/customer",
  UPDATE_CUSTOMER = "/customer/:id",
  DELETE_CUSTOMER = "/customer/:id",
  VIEW_CUSTOMER = "/customers/:id",
  UPLOAD_CUSTOMER_IMAGE = "/customer/:id",
  CUSTOMERS = "/customers",
  CUSTOMER_CATEGORIES = "/customer-categories",
  CUSTOMER_SOURCES = "/customer-sources",
  IMPORT_CUSTOMER_FILE = "/import-customers-file",
  IMPORT_BULK_CUSTOMERS = "/import-bulk-customers",
  EXPORT_CUSTOMERS = "/export-customers",
  PUBLISH_CUSTOMER = "/publish-customer/:id",
  PUBLISH_BULK_CUSTOMER = "/publish-bulk-customer/",
  DELETE_BULK_CUSTOMER = "/delete-bulk-customer/",
  DELETE_CUSTOMER_IMAGE = "/delete-customer-image/:id",
  CREATE_CUSTOMER_ADDRESS = "/customer-address",
  UPDATE_CUSTOMER_ADDRESS = "/customer-address/:id",
  DELETE_CUSTOMER_ADDRESS = "/customer-address/:id",
  PUBLISH_CUSTOMER_ADDRESS = "/publish-customer-address/:id",

  ORDERS = "/orders",
  ORDER_TOTAL_VALUE = "/order-total-value",
  GROUPED_ORDERS = "/time-grouped-orders",
  CREATE_ORDER = "/order",
  UPDATE_ORDER = "/order/:id",
  DELETE_ORDER = "/order/:id",
  VIEW_ORDER = "/orders/:id",
  EXPORT_ORDERS = "/export-orders",
  CHANGE_ORDER_STATUS = "/change-order-status/:id",
  DELETE_BULK_ORDER = "/delete-bulk-order/",
  ASSIGN_BULK_ORDER = "/assign-bulk-order/",

  CONTRACTS = "/company-contracts",
  CREATE_CONTRACT = "/company-contract",
  UPDATE_CONTRACT = "/company-contract/:id",
  DELETE_CONTRACT = "/company-contract/:id",
  PUBLISH_CONTRACT = "/company-contract/:id",
  VIEW_CONTRACT = "/company-contracts/:id",

  COMPANIES = "/companies",
  COMPANY = "/company",
  CREATE_COMPANY = "/company",
  UPDATE_COMPANY = "/company/:id",
  UPDATE_MASTER_RULE = "/company-rule/:id",
  CREATE_MASTER_RULE = "/company-rule",
  CREATE_REGION = "/region",
  UPDATE_REGION = "/region/:id",
  DELETE_REGION = "/region/:id",
  CREATE_STORE_GROUP = "/store-group",
  UPDATE_STORE_GROUP = "/store-group/:id",
  DELETE_STORE_GROUP = "/store-group/:id",
  DELETE_COMPANY = "/company/:id",
  VIEW_COMPANY = "/companies/:id",
  EXPORT_COMPANIES = "/export-companies",
  PUBLISH_COMPANY = "/publish-company/:id",
  PUBLISH_BULK_COMPANY = "/publish-bulk-company/",
  DELETE_BULK_COMPANY = "/delete-bulk-company/",
  DELETE_COMPANY_LOGO = "/delete-company-logo/:id",
  UPLOAD_COMPANY_LOGO = "/company/:id",
  COMPANY_TYPES = "/company-types/",
  CREATED_BY_LIST = "/created-by/",
  PRODUCT_TYPES = "/product-types/",
  PRODUCT = "/product",
  CREATE_PRODUCT = "/product",
  UPDATE_PRODUCT = "/product/:id",
  DELETE_PRODUCT = "/product/:id",
  VIEW_PRODUCT = "/products/:id",
  UPLOAD_PRODUCT_IMAGE = "/product/:id",
  PRODUCTS = "/products",
  PRODUCTS_TO_IMPORT = "/products-to-import",
  COMPANY_PRODUCTS = "/company-products",
  VIEW_COMPANY_PRODUCT = "/company-products/:id",
  DELETE_COMPANY_BULK_PRODUCT = "/delete-company-product",
  IMPORT_PRODUCTS_FOR_COMPANY = "/import-product-for-company",
  STORE_PRODUCTS_TO_IMPORT = "/store-products-to-import",
  STORE_PRODUCTS = "/store-products",
  VIEW_STORE_PRODUCT = "/store-products/:id",
  DELETE_STORE_BULK_PRODUCT = "/delete-store-product",
  IMPORT_PRODUCTS_FOR_STORE = "/import-product-for-store",
  EXPORT_PRODUCTS = "/export-products",
  PUBLISH_PRODUCT = "/publish-product/:id",
  PUBLISH_BULK_PRODUCT = "/publish-bulk-product/",
  DELETE_BULK_PRODUCT = "/delete-bulk-product/",
  DELETE_PRODUCT_IMAGE = "/delete-product-image/:id",
  PRODUCT_FIELDS = "/product-fields",
  PRODUCT_CATEGORIES = "/product-categories",
}

export const HIDE_COMPANY_DROP_DOWN = [
  ContentRoutes.ROLES,
  ContentRoutes.COMPANIES,
  ContentRoutes.CREATE_COMPANY,
  ContentRoutes.PRODUCTS,
  ContentRoutes.CREATE_PRODUCT,
  ContentRoutes.UPDATE_PRODUCT,
  ContentRoutes.UPDATE_ORDER,
  ContentRoutes.IMPORT_PRODUCTS_FOR_COMPANY,
];

export const GET_POPUP_ENUMS = {
  logout: "logout",
  changePasword: "change-password",
  changeSettings: "change-settings",
  changeTheme: "change-theme",
};
